import { reducer as investmentCoveragePlan } from './coverage-plan/reducer'
import { reducer as investmentRisk } from './risk-questionnaire/reducer'
import { reducer as funds } from './fund-allocation/reducer'
import { combineReducers } from 'redux'
import { reducer as proceedToInvestmentProduct } from './validate-permission/reducer'

export const reducer = combineReducers({
  coveragePlan: investmentCoveragePlan,
  investmentRisk: investmentRisk,
  funds: funds,
  proceedToInvestmentProduct,
})
